import BannerContainerBase from 'cookie-banner/base/BannerContainerBase'

export class TeachableBannerContainer extends BannerContainerBase {}

customElements.define('teachable-cookie-policy', TeachableBannerContainer)
